import device from "src/styles/device";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  margin: auto;

  & > div > p {
    word-wrap: break-word;
  }

  h4 {
    font-weight: 600;
    font-size: 1rem;
    margin: 1em 0;
    display: table;

    span {
      display: table-cell;
      font-weight: 500;
      font-size: 1rem;
      padding-right: 0.6em;
    }
  }

  p {
    font-weight: 400;

    &.text-indent {
      text-indent: 24px;

      @media ${device.mobileL} {
        text-indent: 16px;
      }
    }
  }
  p.credit-remark {
    font-weight: 500;
    font-size: 1rem;
    text-align: right;
    margin: 0.5em 0;
  }

  div.number-sublist {
    padding-left: 24px;

    @media ${device.mobileL} {
      padding-left: 16px;
    }
  }
  div.number-sublist > p,
  div.number-sublist > div.multiline {
    display: table;
    font-weight: 400;
    font-size: 1rem;

    &.text-indent {
      text-indent: 24px;

      @media ${device.mobileL} {
        text-indent: 16px;
      }
    }

    span {
      font-weight: 400;
      font-size: 1rem;
      display: table-cell;
      padding-right: 0.4em;
    }
  }

  div.number-sublist > ul {
    padding-left: 24px;

    @media ${device.mobileL} {
      padding-left: 16px;
    }
  }
  div.number-sublist > ul > li {
    list-style: none;
    display: table;
  }
  div.number-sublist > ul > li::before {
    content: "-";
    display: table-cell;
    padding-right: 0.6em;
  }

  ul > li {
    font-weight: 400;
    font-size: 1rem;
    margin-bottom: 0.5em;
  }
`;

const Table = styled.table`
  width: 100%;
  max-width: 1440px;
  margin: 40px 0 20px;
  border: 1px solid black;
  border-spacing: 0px;

  & > thead,
  & > tbody,
  & > tbody > tr {
    border: 1px solid black;
  }

  & > thead > tr > th {
    border: 1px solid black;
    font-weight: 500;
    padding: 8px;
    text-align: center;
  }

  & > tbody > tr > td {
    border: 1px solid black;
    padding: 8px;
  }
`;

const TermContent = ({ contactPercent, hideHeader = false }) => {
  return (
    <Container>
      <div>
        {!hideHeader && (
          <h3
            style={{ "-webkit-text-align": "center", "text-align": "center" }}
          >
            <strong>
              สัญญา ข้อกำหนดและเงื่อนไขการเข้าเป็นร้านค้ากับ “Xsurface”
            </strong>
          </h3>
        )}

        <p>
          เริ่มใช้สำหรับการขายหรือให้บริการตั้งแต่วันที่
          <span>&nbsp; </span>29 เดือน กุมภาพันธ์ 2567 เป็นต้นไป
        </p>
        <p>
          ข้อกำหนดเงื่อนไข ค่าบริการและการบริการทั่วไปของผู้ขาย Xsurface
          ตกลงอนุญาตและผู้ขายตกลงรับการอนุญาตเข้าเป็นร้านค้าเพื่อจําหน่ายสินค้าและ/หรือบริการ
          <span>&nbsp; </span>เป็น 2 ประเภท คือ แบบขายสินค้าผ่านXsurface
          <span>&nbsp; </span>และ แบบคิดค่านายหน้าโดยมีค่าธรรมเนียมดังนี้
        </p>
        <p>
          ในการใช้บริการ Xsurface
          ถือว่าผู้ขายยินยอมจ่ายค่าธรรมเนียมขั้นต่ำตามรายการนี้
        </p>

        <Table>
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>ลักษณะในการขาย</th>
              <th>รายละเอียด</th>
              <th>ค่าธรรมเนียมเริ่มต้น*</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <p>1</p>
              </td>
              <td>
                <p>การขายสินค้าผ่านXsurface</p>
              </td>
              <td>
                <p>
                  ผู้ขายตกลงให้ข้อมูลรายละเอียดของสินค้ากับ Xsurface
                  ทางบริษัทจะทำการตลาดและกำหนดราคาขาย
                </p>
              </td>
              <td>
                <p>-</p>
              </td>
            </tr>

            <tr>
              <td>
                <p>2</p>
              </td>
              <td>
                <p>การจ่ายเปอร์เซ็นต์ให้กับ Xsurface</p>
              </td>
              <td>
                <p>เมื่อมียอดขายผ่านทาง Xsurface ค่าธรรมเนียมขั้นต่ำ ดังนี้</p>
              </td>
              <td>
                <br />
              </td>
            </tr>

            <tr>
              <td>
                <p>2.1</p>
              </td>
              <td>
                <p>ขายสด โดยเงินสดหรือเงินโอน</p>
              </td>
              <td>
                <p>
                  การขายผ่าน หรือค่านายหน้า
                  ที่ลูกค้าจ่ายด้วยเงินสดหรือเงินโอนโดย {contactPercent.desc}{" "}
                  คิดจากยอดสุทธิของสินค้า และ บวก ภาษีมูลค่าเพิ่ม 7%
                </p>
              </td>
              <td>
                <p style={{ whiteSpace: "pre-line" }}>
                  {contactPercent.fee} (+ Vat 7% ของค่าธรรมเนียม)
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>2.2</p>
              </td>
              <td>
                <p>ขายโดยมีการตัดบัตรเครดิต</p>
              </td>
              <td>
                <p>
                  การขายผ่าน หรือค่านายหน้า ที่ลูกค้าชำระเงินด้วยบัตรเครดิตโดย{" "}
                  {contactPercent.desc} คิดจาก ยอดสุทธิของสินค้า กับ
                  ค่าธรรมเนียมบัตร {contactPercent.feeCard} และ บวก
                  ภาษีมูลค่าเพิ่ม 7%
                </p>
              </td>
              <td>
                <p style={{ whiteSpace: "pre-line" }}>
                  {contactPercent.fee}+ {contactPercent.feeCard} (+ Vat 7%
                  ของค่าธรรมเนียม)
                </p>
              </td>
            </tr>
          </tbody>
        </Table>

        <p>
          *ค่าธรรมเนียมในการขายอาจมีการเปลี่ยนแปลงในอนาคต
          และสินค้าแต่ละประเภทอาจมีค่าธรรมเนียมต่างกัน
        </p>

        <p>&nbsp;</p>

        <p>
          ทั้งนี้ความแตกต่างระหว่างการขายทั้ง 2 แบบ (แบบซื้อเข้า
          ขายออกและแบบนายหน้ามีดังนี้)
        </p>
        <p>คำอธิบาย วิธีการขายผ่าน</p>

        {/* 1 */}
        <h4>
          <span>1.</span> การขายผ่าน คือ การที่ผู้ขายให้ Xsurface
          เป็นผู้ทำการขายให้ โดยจะเป็นการขายโดย Xsurface เองไปถึงลูกค้า ทาง
          Xsurface จะทำการซื้อสินค้ามาจากผู้ขายและทำการขายให้ลูกค้า
          โดยมีรายละเอียดดังนี้
        </h4>

        <div className="number-sublist">
          <p>
            <span>1.1</span> เมื่อ Xsurface ทำการขายสินค้าได้
            Xsurfaceจะแจ้งรายละเอียดไปยังผู้ขาย ผู้ขายจะต้องทำการจัดส่ง
            สินค้าที่ลูกค้าได้สั่งซื้อตามรายละเอียดที่ Xsurface แจ้ง
            และผู้ขายจะทำการออกใบเสร็จและใบกำกับภาษีให้ในวันส่งสินค้า โดยทำการ
            scan ส่ง file ให้ทันที และทำการส่งตัวจริงให้ภายในเดือนที่ Xsurface
            ทำการขายได้
          </p>

          <p>
            <span>1.2</span> ผู้ขายจะต้องทำการ Update จำนวนสินค้าและราคา
            ส่ง/หรืออัพเดทในระบบให้ทาง Xsurface ทุกวันก่อนเวลา 10:00 น.
          </p>

          <p>
            <span>1.3</span> ผู้ขายจะได้รับเงินค่าสินค้าดังนี้
          </p>

          <ul>
            <li>
              การสั่งซื้อระหว่างวันที่ 1-30 ของทุกเดือน ผู้ขายจะต้องวางบิลวันที่
              1-5 ของเดือนถัดไป และจ่ายชำระวันที่ 5 ของเดือนถัดไป
            </li>
            <li>
              โดยวันที่ดังกล่าวข้างต้น คิดจากวันที่ทาง Xsurface
              ได้รับเงินเข้าบัญชี หากการนำเงินเข้าบัญชีล่าช้าโดยลูกค้าหรือธนาคาร
              หรือฝ่ายใดที่เกี่ยวข้อง อาจทำให้งวดรับเงินล่าช้าออกไป
            </li>
            <li>
              ทั้งนี้ ผู้ขายจะต้องทำการส่งเอกสารที่ใช้ในการวางบิลตามที่กำหนด
            </li>
          </ul>
        </div>

        {/* 2 */}
        <h4>
          <span>2.</span> ทาง Xsurface
          จะทำการขายโดยกำหนดราคาที่เหมาะสมเองทั้งนี้ถือเป็นสิทธิของ Xsurface
          ที่จะกำหนดราคาขายแต่เพียงผู้เดียว และผู้ขายจะได้รับสิทธิต่างๆ
          ของผู้ขาย เช่นการรวมเป็นแพ็กกลุ่มสินค้าเพื่อเพิ่มโอกาสในการขาย
        </h4>

        <div className="number-sublist">
          <p>
            <span>2.1</span> คำอธิบาย การขายแบบคิดค่าธรรมเนียมค่านายหน้า
          </p>

          <p className="text-indent">
            การคิดค่าธรรมเนียมนายหน้าคือ Xsurface
            จะให้ทำการขายให้กับผู้ซื้อโดยตรง โดยผู้ขายจะถูก หักเปอร์เซ็น (%)
            ตามข้างต้น และ Xsurface
            จะทำการโอนยอดหลังจากหักค่าธรรมเนียมนายหน้าที่เหลือภายใน
            วันเวลาที่กำหนดไว้ ให้กับผู้ขายดังนี้
          </p>
          <p>ผู้ขายจะได้รับเงินค่าสินค้าดังนี้</p>

          <ul>
            <li>
              ผู้ขายจะได้รับเงินจาก Xsurface ในวันที่ 5 ของเดือนถัดไป
              หลังจากวางบิล
            </li>
          </ul>

          <p>
            <span>2.2</span> ผู้ขายจะได้รับใบเสร็จค่าธรรมเนียมในวันที่ 30
            ของทุกเดือน
          </p>

          <p>
            <span>2.3</span> ในกรณีมีงานติดตั้ง หรือค่าแรงต่างๆ
            ผู้ขายจะต้องดำเนินการส่งใบหัก ณ ที่จ่ายให้ เป็นค่าบริการ 3%
            และส่งให้ทาง Xsurface ภายใน 7 วันหลังได้รับเงินจาก Xsurface
          </p>

          <p>
            <span>2.4</span> ผู้ขายจะต้องทำการส่งสินค้าตรงกับ รูปร่างลักษณะ สี
            ราคา คุณภาพตามคำบรรยายที่ให้ไว้ทุกประการ
          </p>
        </div>

        {/* 3 */}
        <h4>
          <span>3.</span> คำอธิบาย การขายแบบคิดค่าธรรมเนียมค่านายหน้า
        </h4>

        <div className="number-sublist">
          <p>
            <span>3.1</span>{" "}
            ภายหลังจากที่ผู้ขายได้ตอบรับคําสั่งซื้อสินค้าของลูกค้าแล้ว
            ผู้ขายมีหน้าที่ส่งสินค้าให้แก่ลูกค้าภายในกําหนดเวลาที่ได้ตกลงกับลูกค้า
            โดยผู้ขายจะจัดให้มีการบรรจุภัณฑ์ หีบห่อ ของสินค้า
            รวมทั้งการส่งมอบสินค้าให้เป็นไปตามมาตรฐาน
            หากผู้ขายใช้บริการผู้ให้บริการร่วมกับ Xsurface
            หรือบุคคลอื่นในการส่งสินค้าผู้ขายยังเป็นผู้มีหน้าที่รับผิดชอบต่อลูกค้าเช่นเดิม
          </p>

          <p>
            <span>3.2</span>{" "}
            ผู้ขายจะต้องเป็นผู้จัดส่งสินค้าให้กับผู้ซื้อด้วยตนเอง
            โดยจะต้องแจ้งให้ทราบล่วงหน้าถึง วันเวลาส่งที่ชัดเจนให้กับทาง
            Xsurface
          </p>

          <p>
            <span>3.3</span>{" "}
            ผู้ขายรับทราบและตกลงว่าหากผู้ขายได้จัดส่งสินค้าที่สี ลาย วัสดุที่
            สินค้าที่แตกต่างอย่างชัดเจน หรือคุณภาพ ไม่เป็นไปตามที่ระบุไว้
            โดยสินค้าไม่สามารถใช้งานตามวัตถุประสงค์ที่ระบุไว้
            หรือสินค้าไม่ได้รับ ใบcertificate หรือไม่ได้มาตรฐานที่ระบุไว้
            ผู้ขายจะต้องรับผิดชอบคืนเงินเต็มจำนวน
            หรือส่งสินค้าทดแทนให้เป็นไปตามที่ระบุ (หากผู้ซื้อต้องการ)
          </p>

          <p>
            <span>3.4</span> ผู้ขายจะต้องจัดส่งสินค้าในเวลาที่เหมาะสม
            และทำการนัดประสานงานกับผู้ซื้อถึงเวลาที่รับสินค้าด้วยตนเอง
          </p>

          <p>
            <span>3.5</span> ผู้ขายต้องแจ้งค่าใช้จ่ายที่เกิดขึ้น วัน เวลา จัดส่ง
            ประสานงานทาง Xsurface ให้ทราบเพื่อทำการยืนยันราคากับลูกค้า
            โดยผู้ขายจะต้องแจ้งราคาค่าขนส่งภายใน 1 วันหลังยืนยันการขาย
          </p>

          <p>
            <span>3.6</span> เมื่อส่งสินค้าให้ผู้ซื้อ
            ผู้ขายจะต้องส่งใบส่งสินค้าและให้ทางผู้รับสินค้าเซ็นรับทราบ
            พร้อมทั้งถ่ายรูปยืนยันและ/หรือวีดิโอการจัดส่งให้ Xsurface
          </p>

          <p>
            <span>3.7</span> หากติดปัญหาประการใดเช่น
            ไม่สามารถส่งสินค้าในเวลาที่ระบุได้ ไม่สามารถติดต่อผู้รับสินค้า
            ได้เมื่อติดต่อหลายครั้ง ต้องแจ้งทาง Xsurface ทันที
          </p>
        </div>

        {/* 4 */}
        <h4>
          <span>4.</span> รายละเอียดของสินค้าและข้อมูลที่ผู้ขายจะเสนอขาย
        </h4>

        <p className="text-indent">
          ผู้ขายมีหน้าที่และความรับผิดชอบในการขายสินค้าซึ่งได้รับอนุญาตตามกฎหมาย
          และเป็นไปตามนโยบายของXSURFACE
          ผู้ขายต้องรับผิดชอบในทุกประเด็นที่เกี่ยวข้องกับสินค้า
          เช่นรายละเอียดเกี่ยวกับสินค้า คุณภาพของสินค้า ถิ่นกำเนิดของสินค้า
          คุณสมบัติของสินค้า กำหนดการส่งสินค้าให้เป็นไปตามที่ตกลงกับผู้ซื้อ
          และใบแจ้งหนี้ทางบัญชีตามที่กฎหมายกำหนด และข้อกำหนดทางภาษีที่เกี่ยวข้อง
          ภายหลังที่ได้มีการขนส่งสินค้าไปยังผู้ซื้อเรียบร้อยแล้ว
          ผู้ขายยังคงต้องรับผิดชอบเกี่ยวกับการคืนสินค้าและการรับประกันสินค้า
        </p>

        <div className="number-sublist">
          <p>
            <span>4.1</span> สินค้าที่ผู้ขายประสงค์จะขายบนตลาดออนไลน์ “Xsurface”
            ผู้ขายตกลงส่งมอบรายการข้อมูลที่สมบูรณ์ถูกต้องให้ Xsurface ดังนี้
            ข้อมูลสินค้า ข้อมูลบริการ สถานที่จัดเก็บสินค้า สถานะของสินค้า
            ระดับสินค้าในสต๊อก ราคาจําหน่าย ค่าขนส่งของสินค้า
            รวมทั้งข้อมูลอื่นใดที่จําเป็นตามมาตรฐานที่ Xsurface กําหนด
          </p>

          <p>
            <span>4.2</span> การลงข้อมูลต่างๆ ในตลาดออนไลน์ “Xsurface”
            ผู้ขายมีหน้าที่ลงข้อมูลที่ถูกต้อง ทั้งคุณภาพสินค้า ราคา
            และรายละเอียดบรรยายวัสดุต่าง ๆ
            ทั้งนี้ผู้ขายยืนยันว่าข้อมูลที่ปรากฏอยู่เป็นข้อมูลที่ถูกต้อง
            ไม่ว่าข้อมูลจะลงโดยผู้ขายหรือไม่ก็ตาม
            ผู้ขายเป็นผู้รับผิดชอบในความถูกต้องของข้อมูลผู้ขายแต่เพียงผู้เดียว
            และมีหน้าที่รับผิดชอบเกี่ยวกับการจัดส่งสินค้าไปยังผู้ซื้อ
            โดยผู้ขายต้องมีสินค้าไว้พร้อมส่งเสมอ
            อีกทั้งผู้ขายจะทำการส่งสินค้าตัวอย่างเพื่อประกอบการตัดสินใจของผู้ซื้อ
            ทั้งนี้
            ผู้ขายมีหน้าที่ต้องตรวจสอบและรักษาความถูกต้องตลอดเวลาโดยเมื่อเกิดความผิดพลาด
            ผู้ขายจะแก้ไขข้อมูลให้ถูกต้องและแจ้งแก่ Xsurface ทันที
          </p>

          <p>
            <span>4.3</span> ผู้ขายเข้าใจและยอมรับว่า Xsurface
            ไม่มีการรับรองความถูกต้องสมบูรณ์หรือผลทางกฎหมายในข้อมูลของผู้ขาย
            ผู้ขายจะต้องรับผิดชอบต่อข้อมูลที่เกี่ยวเนื่องกับการกระทําที่ขัดต่อกฎหมาย
            ความสงบเรียบร้อย และศีลธรรมอันดีของประชาชน
            หรือการละเมิดต่อสิทธิในทรัพย์สินทางปัญญาของบุคคลที่สาม
          </p>

          <p>
            <span>4.4</span> ผู้ขายเข้าใจและยอมรับว่า Xsurface
            มีสิทธินําข้อมูลใดๆ ที่ผู้ขายไปใช้ได้ ทําซ้ำ หรือเผยแพร่ได้
            รวมทั้งมีสิทธิกําหนดรูปแบบ เนื้อหา การประมวลผล อื่นๆในอนาคต
          </p>

          <p>
            <span>4.5</span> Xsurface
            ขอสงวนสิทธิในการถอดถอนข้อมูลของผู้ขายที่ไม่ถูกต้องหรือข้อมูลที่เห็นสมควรที่จะระงับ
            รวมทั้งการทําธุรกรรมใด ๆ
            ที่เกี่ยวข้องของผู้ขายโดยไม่ต้องแจ้งให้ผู้ขายทราบล่วงหน้า
          </p>
        </div>

        {/* 5 */}
        <h4>
          <span>5.</span> กิจกรรมทางด้านการสนับสนุนการค้าและการประชาสัมพันธ์
          และสินค้าตัวอย่าง
        </h4>

        <div className="number-sublist">
          <p>
            <span>5.1</span> Xsurface เป็นผู้มีสิทธิแต่เพียงผู้เดียวในการบริหาร
            กําหนดรูปแบบและดําเนินกิจกรรมทางการค้า
            การโฆษณาและประชาสัมพันธ์และการจัดรายการส่งเสริมการขายบนตลาดออนไลน์
            “Xsurface” โดยจะอนุญาตให้ผู้ขายใช้เครื่องมือสื่อโฆษณา เอกสาร
            และ/หรือ อุปกรณ์ประกอบอื่นใดของ Xsurface เพื่อดําเนินการตามที่กําหนด
          </p>

          <p>
            <span>5.2</span>{" "}
            หากผู้ขายมีความประสงค์จะดําเนินการโฆษณาประชาสัมพันธ์ Xsurface
            มีบริการ Collection การ โปรโมท ผ่านสื่อโซเชียลมีเดียต่างๆ
            และ/หรือส่งเสริมการขายสินค้า
            และ/หรือบริการผ่านช่องทางอื่นสามารถทําได้
            แต่จะไม่ทําการโฆษณาประชาสัมพันธ์ บริการไปในทางที่เสียหาย
            หรืออาจจะเสียหายต่อชื่อเสียง ภาพลักษณ์
            และความน่าเชื่อถือของตลาดออนไลน์ “Xsurface”
          </p>

          <p>
            <span>5.3</span>{" "}
            เพื่อให้สินค้าของผู้ขายสามารถทํายอดขายได้ดีผู้ขายจะทําการสนับสนุน
            “สินค้าแผ่นตัวอย่าง” ให้ Xsurface
            อย่างเพียงพอโดยค่าใช้จ่ายของสินค้าตัวอย่างทั้งสองฝ่ายจะตกลงกันเป็นคราว
            ๆ ไป
          </p>

          <p>
            <span>5.4</span>{" "}
            ในการบริหารกิจกรรมด้านการค้าเพื่อให้สอดคล้องกับวัตถุประสงค์ Xsurface
            มีสิทธิ์ลง และ/หรือ ไม่ลง
            และ/หรือระงับการลงรายการสินค้าของผู้ขายตามดุลพินิจของ Xsurface
          </p>

          <p>
            <span>5.5</span> ผู้ขายได้รับทราบว่าการแสดงผลของวัสดุ บน เว็ปไซต์
            แอปพลิเคชั่น PDF collection หรือสื่ออื่นๆ ของ XSURFACE
            อาจมีความแตกต่างจากสินค้าจริง ทั้งสี ความชัดเจน ผิวสัมผัส
            ลักษณะทางกายภาพ ส่วนประกอบ อื่นๆ
            ผู้ขายมีหน้าที่ตรวจสอบสินค้าด้วยตัวเอง
            หากไม่เป็นไปตามที่วัสดุจริงให้ทำการเปลี่ยนรูปให้เหมาะสม
            ซึ่งถือเป็นหน้าที่ของผู้ขาย
          </p>

          <p>
            <span>5.6</span> ทั้งนี้ Xsurface
            แนะนำให้ผู้ขายจัดเตรียมสินค้าตัวอย่างให้ทาง Xsurface อย่างต่ำ 5
            ชิ้นต่อสินค้าเพื่อความสะดวกและเพิ่มโอกาสในการขาย โดย Xsurface
            ถือสิทธิ์เป็นผู้คัดเลือกในการจัดสรรให้ลูกค้าตามความเหมาะสม
          </p>
        </div>

        {/* 6 */}
        <h4>
          <span>6.</span> การดําเนินการคําสั่งซื้อ
        </h4>

        <div className="number-sublist">
          <p>
            <span>6.1</span>{" "}
            กรณีที่ผู้ขายตอบรับคําสั่งซื้อสินค้าหรือคําสั่งซื้อสินค้าและขอรับบริการของลูกค้า
            Xsurface
            จะแจ้งให้ลูกค้าทราบว่าผู้ขายเป็นผู้ตอบรับคําสั่งซื้อดังกล่าว
            โดยให้ผู้ขายดําเนินการส่งมอบสินค้าหรือให้บริการตามกําหนดต่อไป
          </p>

          <p>
            <span>6.2</span>{" "}
            ผู้ขายจะออกใบกํากับภาษีให้มีจํานวนเท่ากับภาษีมูลค่าเพิ่มที่เรียกเก็บและส่งมอบให้ลูกค้า
            ทันทีที่ความรับผิดชอบในการเสียภาษีมูลค่าเพิ่มเกิดขึ้น
          </p>

          <div className="multiline">
            <span>6.3</span>{" "}
            ค่าขนส่งสินค้าที่เสนอต่อและเรียกเก็บจากลูกค้าเป็นการคํานวณจากอัตราค่าขนส่งของผู้ขายหรืออัตราค่าขนส่งของผู้ขนส่งที่ทางผู้ขายเป็นผู้ดำเนินการหรือเป็นผู้จัดหา
            ควรจะแจ้งรายละเอียดการส่งสินค้า เช่น วันที่และเวลาจัดส่ง ลักษณะ ขนาด
            น้ําหนัก เงื่อนไขต่างๆ เป็นต้น เพื่อให้ผู้รับ หรือลูกค้าทราบล่วงหน้า
            <p className="text-indent">
              กรณีที่ผู้ขายระบุข้อมูลของสินค้าเช่น ลักษณะ ขนาด น้ําหนัก
              สินค้าให้ผิดพลาด
              และส่งผลให้ผู้รับสินค้าหรือลูกค้าไม่สามารถรับสินค้าได้
              ผู้ขายจะเป็นผู้รับผิดชอบค่าใช้จ่ายส่วนที่เพิ่มขึ้นด้วยแต่เพียงผู้เดียว
            </p>
          </div>

          <div className="multiline">
            <span>6.4</span>{" "}
            ภายหลังจากที่ผู้ขายตอบรับคําสั่งซื้อสินค้าหรือคําเสนอขอรับบริการของลูกค้าแล้วผู้ขายจะพยายามอย่างสุดความสามารถในการจัดการคําสั่งซื้อให้เป็นไปตามเงื่อนไขและข้อกําหนดของ
            Xsurface และจะไม่ยกเลิกหรือเพิกถอน
            คําตอบรับดังกล่าวไม่ว่าด้วยเหตุผลใด ๆ ก็ตาม
            <p className="text-indent">
              ผู้ขายตกลงจะไม่กระทําการใด ๆ เพื่อเปลี่ยนแปลงสินค้า การบริการ
              การขนส่ง หรือเงื่อนไขใด ๆ
              ที่ระบุไว้ในคําสั่งซื้อหรือคําเสนอขอรับบริการของลูกค้า
              เว้นแต่ได้รับความยินยอมจาก Xsurface
            </p>
            <p className="text-indent">
              กรณีเกิดความเสียหายขึ้นจากการเปลี่ยนแปลงคําสั่งซื้อสินค้า
              หรือคําเสนอขอรับบริการของลูกค้าที่มีการชําระเงินแล้ว
              โดยมิได้รับความยินยอมจาก Xsurface
              ผู้ขายตกลงเป็นผู้รับผิดชอบในความเสียหายดังกล่าว
              และ/หรือลูกค้ามีการเปลี่ยนแปลงปริมาณในการสั่งซื้อหรือรายละเอียดใดๆในการสั่งสินค้าในภายหลังจากการคำสั่งซื้อไปแล้ว
              หากเป็นการสั่งตรงไปยังผู้ขายมีความผิดพลาดใดๆ
              ผู้ขายจะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียว
            </p>
            <p className="text-indent">
              แต่ในกรณีที่มีความจําเป็นหรือผู้ขายเพิกเฉยไม่ดําเนินการเข้าแก้ไขหรือรับผิดชอบในความเสียหายที่เกิดขึ้น
              Xsurface อาจดําเนินการแทนผู้ขาย
              โดยผู้ขายตกลงจะรับผิดชอบค่าใช้จ่ายที่เกี่ยวข้องกับการดําเนินการนั้นให้แก่
              Xsurface
            </p>
          </div>

          <p>
            <span>6.5</span> Xsurface
            เป็นผู้มีสิทธิในการบริหารจัดการคําสั่งซื้อจากลูกค้า
            การตอบรับคําเสนอซื้อของผู้ขายรวมทั้งมีสิทธิระงับการดําเนินการหรือไม่ดําเนินการใดๆที่เห็นสมควร
            โดยผู้ขายจะไม่เรียกร้องค่าเสียหายจาก Xsurface
            ทั้งนี้ผู้ขายยินยอมรับโดยอัตโนมัติในทุกการดำเนินการบนตลาดออนไลน์
            “Xsurface”
          </p>

          <p>
            <span>6.6</span>{" "}
            ในกรณีที่ผู้ขายทําการยกเลิกคําสั่งซื้อสินค้าหรือคําเสนอขอรับบริการจากลูกค้า
            หรือถูกยกเลิกคําสั่งซื้อเนื่องจากจัดการคําสั่งซื้อล่าช้า
            หรือถูกยกเลิกคําสั่งซื้อจากผู้ซื้อเนื่องจากเป็นความผิดของผู้ขาย
            Xsurface มีสิทธิเรียกร้องค่าธรรมเนียมการยกเลิกคําสั่งซื้อ และ/หรือ
            ค่าใช้จ่ายที่เกิดขึ้นจากผู้ขายเพิ่มเติม
          </p>
        </div>

        {/* 7 */}
        <h4>
          <span>7.</span> ข้อผิดพลาด ข้อบกพร่อง
          และการส่งสินค้าที่ไม่ตรงตามคำประกาศของสินค้า
        </h4>

        <div className="number-sublist">
          <p>
            <span>7.1</span> Xsurface
            เป็นตัวกลางในการรับเรื่องร้องเรียนต่อสินค้าและบริการที่ลูกค้าได้รับผ่านตลาดออนไลน์
            “Xsurface” และ Xsurface ตกลงจะเป็นผู้เจรจากับลูกค้า
            และแก้ไขปัญหาในเบื้องต้นให้แก่ลูกค้า กรณีที่ต้องมี
            การเปลี่ยนแปลงสินค้าที่ได้ส่งแล้วหรือบริการที่ดําเนินการไปแล้วผู้ขายรับทราบว่าเป็นหน้าที่ของผู้ขาย
            ที่จะต้องดําเนินการ
            อย่างไรก็ดีในกรณีที่มีความจําเป็นหรือผู้ขายเพิกเฉยไม่ดําเนินการดังกล่าว
            Xsurface
            อาจดําเนินการแทนผู้ขายและผู้ขายจะรับผิดชอบค่าใช้จ่ายที่เกี่ยวข้องกับการดําเนินการต่อไป
          </p>

          <p>
            <span>7.2</span>{" "}
            กรณีที่ลูกค้าติดต่อไปยังผู้ขายโดยตรงผู้ขายตกลงจะแจ้งให้ลูกค้าติดต่อมายัง
            Xsurface เพื่อให้Xsurfaceเป็นผู้ดําเนินการต่อไป
            เพื่อให้การบริการแก่ลูกค้าเป็นไปในรูปแบบเดียวกันตามที่ Xsurface
            กําหนดไว้
          </p>

          <p>
            <span>7.3</span> สินค้าส่งคืนและการจัดส่งที่ผิดพลาด
            ผู้ขายตกลงรับผิดชอบกรณีที่จัดส่งสินค้าหรือให้บริการแก่ลูกค้าไม่ถูกต้องอย่างชัดเจน
            หากลูกค้าร้องเรียนมายัง Xsurface ผู้ขายตกลงให้ Xsurface ดําเนินการใด
            ๆ
            แทนผู้ขายตามสมควรและยินดีชดใช้ค่าใช้จ่ายและค่าเสียหายทั้งหมดคืนให้แก่
            Xsurface ผู้ขายตกลงดําเนินการจัดส่งสินค้า เข้าสํารวจหน้างาน
            รวมถึงบริการให้แก่ลูกค้าภายในระยะเวลาตามที่กําหนดในสัญญาฉบับนี้
            หากเกิดสุดวิสัยหรือเหตุใดๆ
            ทําให้ผู้ขายไม่สามารถดําเนินการภายในเวลาดังกล่าวได้ผู้ขายจะแจ้งให้
            Xsurface ทราบ โดยเร็วที่สุด
            ทั้งนี้ทั้งสองฝ่ายตกลงจะร่วมกันแก้ไขปัญหาร่วมกันโดยเร็ว
          </p>

          <p>
            <span>7.4</span>{" "}
            ผู้ขายตกลงจะให้ลูกค้ามีสิทธิเลิกสัญญาได้ตามสิทธิของลูกค้าซึ่งกําหนดตามกฎหมายว่าด้วยการขายตรงและตลาดแบบตรง
            ซึ่งลูกค้ามีสิทธิส่งหนังสือบอกเลิกสัญญาภายในเวลา 7 วัน
            นับแต่วันที่ได้รับสินค้า และผู้ขายจะต้องคืน
            เงินให้แก่ลูกค้าภายในเวลา 15 วัน
            นับแต่วันที่ผู้ขายได้รับสินค้าตามหนังสือบอกเลิกสัญญาและผู้ขายตกลงไม่เรียกร้องค่าเสียหายหรือ
            ค่าธรรมเนียมหรือค่าบริการที่ชําระให้กับ Xsurface
            หรือผู้ให้บริการร่วมกับ Xsurface แล้ว
          </p>
        </div>

        {/* 8 */}
        <h4>
          <span>8.</span> การติดตั้งสินค้าหน้างานกับผู้ซื้อ
          ในกรณีที่สินค้าที่ลูกค้าสั่งสินค้าที่มีการบริการติดตั้งของผู้ขาย
          ไม่ว่าจะเป็นการรวมค่าติดตั้งในราคาสินค้าก็ดี
          หรือคิดค่าใช้จ่ายเพิ่มเติมก็ดี
          ผู้ขายที่ให้บริการการติดตั้งจะต้องทำการติดตั้งให้เสร็จสมบูรณ์
          โดยใช้วัสดุเครื่องมือส่วนประกอบต่างๆ
          และแรงงานจะต้องเป็นไปตามมาตราฐานหรือข้อตกลงคำโฆษณา
          และจะต้องปฏิบัติตามเงื่อนไขดังนี้
        </h4>

        <p className="text-indent">
          หากมีการคิดค่าใช้จ่ายเพิ่มเติม เช่น การสำรวจหน้างานก่อนติดตั้ง
          ค่าเดินทาง ค่าติดตั้งวัสดุ/งานในที่สูง ค่าติดตั้งงานในตึกสูง
          หรือค่าใช้จ่ายอื่นๆใด จะต้องทำการแจ้งให้ลูกค้าทราบก่อน
          ล่วงหน้าเท่านั้น
        </p>

        <div className="number-sublist">
          <div className="multiline">
            <span>8.1</span>{" "}
            ในการติดตั้งผู้ขายจะต้องรักษาหน้างานของลูกค้าให้เป็นไปโดยเรียบร้อย
            ทั้งการรักษาวัสดุอุปกรณ์ต่างๆ
            ที่อยู่หน้างานและรักษาความสะอาดหน้างานให้เป็นไปอย่างดี
            หากงานติดตั้งมีความไม่เรียบร้อย ไม่ว่าจะเกิดจากผู้ขาย
            หรือเหตุอื่นใดที่ทำให้งานติดตั้งไม่เสร็จสมบูรณ์
            ให้ทำการแก้ไขโดยทันที หากไม่สามารถแก้ไขได้ให้แจ้งลูกค้าทราบโดยทันที
            และให้ทำการแก้ไขให้เสร็จโดยสมบูรณ์ในเวลาไม่เกิน 3 วัน
            <p className="text-indent">
              หลังจากงานติดตั้งเสร็จสินสิ้น
              ผู้ขายจะต้องทำการส่งมอบงานและให้ลูกค้าเซ็นรับมอบงาน
              และส่งใบรับมอบงานให้ทาง Xsurface ในเวลา 24 ชั่วโมง
              หากมีการประกันงานผู้ขายจะต้องทำการประกันตามที่ได้ระบุไว้
              และ/หรือทางลูกค้าพบเจอตำหนิหรือวัสดุตำหนิ หรือข้อบกพร่องใดๆ
              ในการติดตั้ง
              ผู้ขายจะต้องดำเนินการตรวจสอบและแก้ไขให้ลูกค้าอย่างเหมาะสมภายใน 15
              วันหลังจากได้รับแจ้ง
            </p>
          </div>

          <p>
            <span>8.2</span>{" "}
            ในกรณีที่เป็นเรื่องเกี่ยวกับความปลอดภัยผู้ขายต้องทำการแก้ไขโดยทันที
            หากผู้ขายไม่แก้ไข ตำหนิหรือข้อบกพร่องที่ลูกค้าแจ้ง
            ให้แจ้งเป็นลายลักษณ์อักษรถึงทางXsurface
            ให้ทราบพร้อมทั้งระบุเหตุการณ์
            และข้อบกพร่องหรือตำหนิที่ไม่ได้แก้ให้ชัดเจน
            โดยจะต้องเป็นไปตามหลักการและมาตราฐานของวัสดุนั้นๆหรือพิสูจน์ถึงความเสียหายไม่ได้เกิดจากวัสดุหรือผู้ติดตั้ง
            และทำการแจ้งกับลูกค้าให้ชัดเจน
          </p>

          <p>
            <span>8.3</span> เงื่อนไขใดๆที่ไม่รวมการรับประกัน
            ผู้ขายจะต้องระบุให้ผู้ซื้อทราบให้ชัดเจน
            ก่อนทำการติดตั้งหน้างานทุกกรณี
          </p>

          <div className="multiline">
            <span>8.4</span> มาตราฐานการติดตั้งและการรับประกัน เป็นไปตามแต่ละ
            ผู้ขาย/ผู้ติดตั้ง โดยXsurfaceขอให้แจ้งลูกค้าทราบให้ชัดเจน
            ก่อนทำการติดตั้งหน้างาน
            ทางผู้ขายจะต้องเป็นผู้รับผิดชอบในงานติดตั้งทั้งหมดไม่ว่าจะเป็นการกระทำด้วยตัวผู้ขายหรือตัวแทนที่ผู้ขายได้จัดหามาก็ตาม
            หากผู้ขายไม่ได้ติดตั้งให้เป็นไปอย่างสมบูรณ์
            หรือเป็นไปตามที่ระบุตกลงไว้ ทางXsurface
            สามารถกันเงินบางส่วนหรือทั้งหมดไว้
            จนกว่าผู้ขายจะทำการแก้ไขจนเสร็จสิ้นได้ หรือทางXsurface
            สามารถใช้เงินที่รับมาจากลูกค้าแล้ว ทำการแก้ไขให้เป็นไปตามที่ระบุได้
            และจะคืนเงินส่วนที่เหลือหลังจากหักค่าใช้จ่ายที่เกิดขึ้นตามจริง
            ซึ่งอาจรวมค่าเดินทาง ค่าว่าจ้างผู้ชำนาญการ
            ค่าตรวจสอบต่างๆและ/หรือสรุปค่าใช้จ่ายที่เหมาะสม
            <p className="text-indent">
              ผู้ขายทราบดีว่า ทาง Xsurface ไม่รับผิดชอบความบกพร่องหรือปัญหาใดๆ
              ที่เกิดขึ้นในการติดตั้ง
              เป็นเรื่องระหว่างผู้ขายและผู้ซื้อที่จะต้องทำการดำเนินการเอง
              ผู้ขายจะต้องเป็นผู้ตรวจสอบ ทำความเข้าใจลักษณะงานต่างๆ ด้วยตนเอง
            </p>
          </div>
        </div>

        {/* 9 */}
        <h4>
          <span>9.</span>{" "}
          นโยบายการคุ้มครองข้อมูลส่วนบุคคลผู้ขายได้อ่านกฎเกณฑ์ข้อบังคับและเงื่อนไขในการขายและตกลงตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้อง
          และยินยอมให้ XSURFACE ดำเนินการเก็บ รวบรวม ใช้
          รักษาและเปิดเผยข้อมูลส่วนบุคคลของผู้ขายเพื่อเป็นไปตามวัตถุประสงค์ที่ได้กำหนดไว้ในนโยบายการคุ้มครองข้อมูลส่วนบุคคล
        </h4>

        <div className="number-sublist">
          <p>
            <span>9.1</span>{" "}
            ผู้ขายในฐานะผู้รับข้อมูลส่วนบุคคลตกลงจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
            และจะดําเนินการใดๆเกี่ยวกับข้อมูลส่วนบุคคลที่ได้รับจาก Xsurface
            ตามที่กําหนดไว้ในสัญญานี้
          </p>

          <p>
            <span>9.2</span> เมื่อ Xsurface ร้องขอผู้ขายจะสนับสนุน Xsurface
            เพื่อให้ Xsurface
            ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลสําหรับข้อมูลส่วนบุคคลที่
            Xsurface ได้ส่งให้อย่างเต็มความสามารถ เช่น
            การตอบสนองต่อคําร้องขอใช้สิทธิของ เจ้าของข้อมูลส่วนบุคคล
            รวมถึงจะดําเนินการลบ และ/หรือ คืนข้อมูลส่วนบุคคลให้ Xsurface
            ทั้งหมดภายในเวลาที่ Xsurface กําหนด
          </p>

          <p>
            <span>9.3</span> ผู้ขายต้องแจ้งให้ Xsurface
            ทราบทันทีเมื่อเกิดเหตุการรั่วไหล การละเมิด การเข้าถึง ใช้
            หรือเปลี่ยนแปลงข้อมูลส่วนบุคคลที่ตนได้รับจาก Xsurface
            โดยไม่ได้รับอนุญาต และ
            ผู้ขายต้องไม่นําเสนอข้อมูลลูกค้าไปใช้เพื่อการอื่นโดยไม่ได้รับความยินยอมจาก
            Xsurface
          </p>
        </div>

        {/* 10 */}
        <h4>
          <span>10.</span> การยุติ หรือสิ้นสุดความสัมพันธ์ระหว่างคู่สัญญา
        </h4>

        <p className="text-indent">
          ผู้ขายสามารถยุติสถานภาพในการเป็นผู้ขายกับทางXSURFACE ไม่ว่าในเวลาใด
          ซึ่งผู้ขายจะต้องบอกกล่าวให้XSURFACE
          ทราบล่วงหน้าเป็นลายลักษณ์อักษรเป็นเวลาไม่น้อยกว่า 30 วัน
          ทั้งนี้ในระหว่างก่อนเลิกสัญญา
          หากยังมีการสั่งซื้อจากลูกค้าค้างอยู่ผู้ขายจะต้องทำการส่งสินค้าตามที่ระบุไว้ให้กับผู้ซื้อตามรายละเอียด
          ข้อตกลงทั้งหมด
        </p>

        {/* 11 */}
        <h4>
          <span>11.</span> การระงับข้อพิพาท
        </h4>

        <p className="text-indent">
          กฎเกณฑ์ข้อบังคับและเงื่อนไขต่าง ๆ
          อยู่ภายในเขตอำนาจศาลที่XSURFACEตั้งอยู่
          ในกรณีที่ผู้ขายไม่เห็นด้วยหรือมีข้อขัดข้องประการใด
          คู่สัญญาสามารถตกลงดำเนินการยุติข้อขัดข้องนั้นฉันท์มิตรได้
          หากไม่สามารถตกลงกันได้
          คู่สัญญาฝ่ายใดฝ่ายหนึ่งสามารถนำข้อขัดแย้งดังกล่าวไปสู่กระบวนการอนุญาโตตุลาการ
          กรณีมีข้อพิพาทนอกประเทศให้บังคับใช้ตามกฎหมายไทยโดยการใช้บริการตลาดออนไลน์
          “Xsurface”
          จากทั้งในและนอกประเทศไทยผู้ขายจะต้องปฏิบัติตามกฎหมายของประเทศไทย
        </p>

        <p>&nbsp;</p>

        <p>
          ผู้ขายตกลงและยืนยันจะปฎิบัติตามเนื้อหาตามข้างต้นทั้งหมดและปฎิบัติตามเงื่อนไขและการบริการสำหรับผู้ขาย
          ของ Xsurface
        </p>

        <p>
          ทั้งนี้เนื้อหาส่วนหนึ่งส่วนใด
          หรือทั้งหมดก็ตามอาจเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
        </p>

        <p>&nbsp;</p>

        <p className="credit-remark">บริษัท เอ็กซ์เซอร์เฟซ จำกัด</p>
        <p className="credit-remark">FEB 29, 2024</p>

        <p>&nbsp;</p>

        <p>
          ผู้ขายมีหน้าที่ส่งเอกสารให้ XSURFACE เพื่อทำการวางบิลรับชำระเงินตามนี้
        </p>

        <img
          src="https://xsurface-images.s3.ap-southeast-1.amazonaws.com/billing_process_image.jpg"
          alt="xsurface-tutorial"
          style={{ width: "100%", height: "auto", margin: "16px 0" }}
        />
      </div>
    </Container>
  );
};

export default TermContent;
